// Billing status for the signed-in workspace (Service.Subscription function URL — the same
// endpoint Studio and account.plunk.io use). Cached 60 s; never throws: callers treat null as
// "unknown" and must fail OPEN (a billing hiccup can't lock the App).
import account from "../data/account";
import { AuthBase } from "../../plunk/service/auth-base";
const BILLING_BASE = "https://el72ltksxlc7b72mx6tai7n5qa0ppxvt.lambda-url.us-east-1.on.aws";
const TTL = 60 * 1000;
let _cache = null; // { at, tenant, data }

export function clearBillingStatusCache() {
  _cache = null;
}
export async function getBillingStatus(force) {
  const tenant = ((account.get() || {}).tenantId || "").trim();
  if (!tenant) return null;
  if (!force && _cache && _cache.tenant === tenant && Date.now() - _cache.at < TTL) return _cache.data;
  try {
    const token = AuthBase.idToken;
    if (!token) return null;
    const res = await fetch(`${BILLING_BASE}/v1/billing/status`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-id": tenant
      }
    });
    if (!res.ok) return null;
    const data = await res.json();
    _cache = {
      at: Date.now(),
      tenant,
      data
    };
    return data;
  } catch (e) {
    return null;
  }
}

// Where the live plans are billed: ["shopify"], ["stripe"], both, or [] (managed / no plan).
export async function getBillingSources(force) {
  const s = await getBillingStatus(force);
  if (!s) return null;
  if (Array.isArray(s.billingSources)) return s.billingSources.map(x => String(x || "").toLowerCase());
  return s.subscription && s.subscription.source ? [String(s.subscription.source).toLowerCase()] : [];
}

// Live plan keys on the workspace (Stripe or Shopify): ["studio_pro", "commerce", ...].
export async function getLivePlans(force) {
  const s = await getBillingStatus(force);
  if (!s) return null;
  if (Array.isArray(s.plans)) return s.plans.map(p => String(p || "").toLowerCase());
  return s.subscription && s.subscription.planKey ? [String(s.subscription.planKey).toLowerCase()] : [];
}